import { getManager } from '@cp/shared/api/socket';
import { IConfigManager } from '../../../../shared/config';
import { SocketDialogApiConfig } from './config';

export const createSocket = (params: SocketDialogApiConfig, cm: IConfigManager) => {
  const manager = getManager(cm);
  return manager.socket('/dialog', { auth: { token: params.authToken } });
};
